import { Box, Button, CircularProgress, Divider, Grid, Typography } from "@mui/material";

import { FieldControl } from "../../../shared/components";
import { useGetStandardColumns } from "../hooks/useGetStandardColumns";
import { useGenerateExport } from "../hooks/useGenerateExport";

export const ExportDialog = ({ onSuccess }: { onSuccess: () => void }) => {

    const { data, isLoading, isError } = useGetStandardColumns();

    const { selectedReport, setSelectedReport, fieldErrors, handleReset, generateExport, generating, error } = useGenerateExport({
        onSuccess: () => {
            onSuccess();
        }
    });

    if (isLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                my={5}
            >
                <CircularProgress />
            </Box>
        );
    };

    return (
        <Grid container p={2} spacing={3}>
            <Grid size={12} px={1}>
                <Typography variant="subtitle1" color="textSecondary">
                    Please select the report template and date range for the report you want to export.
                </Typography>
            </Grid>
            <Grid size={12}>
                <FieldControl
                    keyName="reportKey"
                    variant="select"
                    label={"Select Report Template"}
                    options={data.map((report: any) => ({
                        label: report.display_name,
                        value: report.report_name
                    }))}
                    value={selectedReport.reportKey}
                    onChange={(_key: string, value: string) => setSelectedReport(prev => ({ ...prev, reportKey: value }))}
                    error={!!fieldErrors.reportKey}
                    helperText={fieldErrors.reportKey}
                />
            </Grid>
            <Grid size={6}>
                <FieldControl
                    keyName="reportStartDate"
                    variant="date"
                    label={"Select Report Start Date"}
                    value={selectedReport.reportStartDate}
                    onChange={(_key: string, value: string) => setSelectedReport(prev => ({ ...prev, reportStartDate: value }))}
                    error={!!fieldErrors.reportStartDate}
                    helperText={fieldErrors.reportStartDate}
                    maxDate={new Date()}
                    minDate={selectedReport.reportEndDate}
                />
            </Grid>
            <Grid size={6}>
                <FieldControl
                    keyName="reportEndDate"
                    variant="date"
                    label={"Select Report End Date"}
                    value={selectedReport.reportEndDate}
                    onChange={(_key: string, value: string) => setSelectedReport(prev => ({ ...prev, reportEndDate: value }))}
                    minDate={selectedReport.reportStartDate || undefined}
                    maxDate={new Date()}
                    error={!!fieldErrors.reportEndDate}
                    helperText={fieldErrors.reportEndDate}
                />
            </Grid>
            <Grid size={12}>
                <Divider flexItem />
            </Grid>
            <Grid size={12} display={'flex'} justifyContent={'flex-end'} gap={2}>
                <Button variant="outlined" onClick={handleReset} disabled={generating}>Reset</Button>
                <Button variant="contained" onClick={generateExport} disabled={generating}>Export</Button>
            </Grid>
        </Grid>
    );

};